import React from "react";
import { Truck, ShoppingBag, Headset, RefreshCw } from "lucide-react";
import logo from "../assets/images/h1.gif";

const FEATURES = [
  {
    icon: Truck,
    title: "Fast & Discreet Delivery",
    description:
      "Your BioSurge product delivered quickly with secure and discreet packaging.",
  },
  {
    icon: RefreshCw,
    title: "Herbal Quality Assurance",
    description:
      "Crafted with carefully selected herbs to support stamina, vitality, and overall wellness.",
  },
  {
    icon: Headset,
    title: "Personal Support",
    description:
      "Have questions about energy, performance, or usage? Our team is always here to guide you.",
  },
  {
    icon: ShoppingBag,
    title: "Simple & Safe to Use",
    description:
      "Easy daily intake, designed to fit seamlessly into your modern lifestyle.",
  },
];


const FeatureCard = ({ Icon, title, description }) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      backgroundColor: 'black',
      // borderRadius: "12px",
      // padding: "20px",
      // border: "1px solid whitesmoke",
      marginBottom: "20px",
      // boxShadow: "0 4px 10px rgba(0,0,0,0.1)",

      color: 'whitesmoke',
      borderRadius: "8px",
      boxShadow: "0 4px 20px rgb(26 201 66 / 33%)",
      transition: "all 0.2s ease-in-out",
      padding: "0.8rem 1rem",
    }}
  >
    <div
      style={{
        backgroundColor: "#fff",
        color: "#222121ff",
        borderRadius: "50%",
        padding: "10px",
        marginRight: "15px",
      }}
    >
      <Icon size={24} />
    </div>
    <div>
      <h3 style={{ fontSize: "18px", fontWeight: "700", color: 'whitesmoke' }}>
        {title}
      </h3>
      <p style={{ color: 'whitesmoke', fontSize: "14px" }}>{description}</p>
    </div>
  </div>
);

const About = () => {
  return (
    <div style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#FAFAF9" }}>

      {/* Hero / Story Section */}
      <header
        style={{
          backgroundImage: `url(${logo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "#fff",
          padding: "100px 20px",
          textAlign: "center",

          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",

          }}
        ></div>

       <div style={{ position: "relative", zIndex: 2, maxWidth: "800px", margin: "0 auto" }}>
  <h1 style={{ fontSize: "48px", fontWeight: "800", marginBottom: "20px" }}>
    BioSurge <span style={{ color: 'whitesmoke' }}>Herbal Wellness Blend</span>
  </h1>

  <p style={{ fontSize: "18px", lineHeight: "1.8" }}>
    BioSurge is a plant-based herbal formulation crafted to complement modern
    lifestyles. It supports daily energy, helps reduce tiredness, and promotes
    a balanced and active routine with its traditional honey-based blend.
  </p>

  {/* Storytelling Blocks */}
  <div style={{ marginTop: "50px", textAlign: "left", color: 'whitesmoke', lineHeight: "1.7" }}>
    
    <h2 style={{ fontSize: "28px", fontWeight: "700", marginBottom: "15px" }}>
      Why BioSurge Exists
    </h2>
    <p>
      Modern life often brings stress, long work hours, and demanding routines
      that can leave you feeling drained. BioSurge was created as a traditional
      herbal blend to support everyday wellness and help maintain a balanced lifestyle.
    </p>

    <h2 style={{ fontSize: "28px", fontWeight: "700", margin: "25px 0 15px" }}>
      What BioSurge Offers
    </h2>
    <p>
      Made with carefully selected herbal ingredients, BioSurge complements
      your daily routine by supporting natural energy levels, nourishment,
      and overall wellbeing — without artificial stimulants.
    </p>

    <h2 style={{ fontSize: "28px", fontWeight: "700", margin: "25px 0 15px" }}>
      Beyond Daily Routine
    </h2>
    <p>
      More than just a supplement, BioSurge fits seamlessly into your lifestyle,
      helping you stay consistent, active, and balanced while embracing a
      traditional approach to herbal wellness.
    </p>

  </div>
</div>
      </header>

      {/* Features Section */}
      <section style={{ padding: "80px 20px", backgroundColor: 'black' }}>
        <h2 style={{ fontSize: "32px", fontWeight: "800", textAlign: "center", marginBottom: "50px", color: 'whitesmoke' }}>
          Why Choose Us
        </h2>
        <div style={{ maxWidth: "1000px", margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px", }}>
          {FEATURES.map((f, i) => (
            <FeatureCard Icon={f.icon} title={f.title} description={f.description} key={i} />
          ))}
        </div>
      </section>

    </div>
  );
};

export default About;
